import { RootCause, RootCauseCategory } from '.';
import * as _ from 'lodash';

export class PossibleRootCauseCategory {
    // This is a special category that needs to remain even if we have iron panel markers.
    static CATEGORY_1 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_1,
        possibleRootCauses: [        
            RootCause.APLASTIC_ANEMIA
        ]
    });

    static CATEGORY_2 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_2,
        possibleRootCauses: [   
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_21 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_21,
        possibleRootCauses: [   
            RootCause.BLOOD_LOSS_ACUTE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_22 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_22,
        possibleRootCauses: [   
            RootCause.BLOOD_LOSS_ACUTE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_23 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_23,
        possibleRootCauses: [   
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_24 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_24,
        possibleRootCauses: [   
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_25 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_25,
        possibleRootCauses: [   
            RootCause.B2_RIBOFLAVIN_INSUFFICIENCY,
            RootCause.LOW_TESTOSTERONE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_26 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_26,
        possibleRootCauses: [   
            RootCause.VITAMIN_C_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_3 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_3,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY_B12_FOLATE_DEFICIENCY,
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_31 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_31,
        possibleRootCauses: [
            RootCause.RENAL_DISEASE
        ]
    });

    static CATEGORY_32 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_32,
        possibleRootCauses: [
            RootCause.VITAMIN_C_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_33 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_33,
        possibleRootCauses: [
            RootCause.STOMACH_ACID_INSUFFICIENCY_POSSIBLY_CAUSING_IRON_AND_OR_B12_INSUFFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_34 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_34,
        possibleRootCauses: [
            RootCause.ZINC_INSUFFICIENCY_STOMACH_ACID
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_4 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_4,
        possibleRootCauses: [        
            RootCause.IRON_INSUFFICIENCY,
            RootCause.VITAMIN_A_DEFICIENCY,
            RootCause.COPPER_DEFICIENCY,
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ],
        isDeterminedOnlyByRBC: true
    });

    // static CATEGORY_42 = new PossibleRootCauseCategory({
    //     rootCauseCategory: RootCauseCategory.CATEGORY_42,
    //     possibleRootCauses: [
    //         RootCause.VITAMIN_B6_DEFICIENCY,
    //         RootCause.ZINC_DEFICIENCY
    //     ],
    //     isDeterminedOnlyByRBC: true
    // });

    // static CATEGORY_43 = new PossibleRootCauseCategory({
    //     rootCauseCategory: RootCauseCategory.CATEGORY_43,
    //     possibleRootCauses: [
    //         RootCause.VITAMIN_B6_DEFICIENCY
    //     ],
    //     isDeterminedOnlyByRBC: true
    // });

    // static CATEGORY_44 = new PossibleRootCauseCategory({
    //     rootCauseCategory: RootCauseCategory.CATEGORY_44,
    //     possibleRootCauses: [
    //         RootCause.ZINC_DEFICIENCY
    //     ],
    //     isDeterminedOnlyByRBC: true
    // });

    static CATEGORY_5 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_5,
        possibleRootCauses: [        
            RootCause.IRON_INSUFFICIENCY,
            RootCause.VITAMIN_A_DEFICIENCY,
            RootCause.COPPER_DEFICIENCY,
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_51 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_51,
        possibleRootCauses: [        
            RootCause.VITAMIN_C_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_52 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_52,
        possibleRootCauses: [        
            RootCause.SIDEROBLASTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_53 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_53,
        possibleRootCauses: [        
            RootCause.SIDEROBLASTIC_ANEMIA_VITB6
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_54 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_54,
        possibleRootCauses: [        
            RootCause.SIDEROBLASTIC_ANEMIA_ZINC
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_55 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_55,
        possibleRootCauses: [        
            RootCause.SIDEROBLASTIC_ANEMIA_VITB_ZINC
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_56 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_56,
        possibleRootCauses: [        
            RootCause.THALASSEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_57 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_57,
        possibleRootCauses: [        
            RootCause.BLOOD_LOSS_CHRONIC
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_58 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_58,
        possibleRootCauses: [        
            RootCause.BLOOD_LOSS_CHRONIC
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_59 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_59,
        possibleRootCauses: [        
            RootCause.SIDEROBLASTIC_ANEMIA_VITB_ZINC
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_6 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_6,
        possibleRootCauses: [        
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_63 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_63,
        possibleRootCauses: [        
            RootCause.CONGENITAL_SPHEROCYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_64 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_64,
        possibleRootCauses: [        
            RootCause.HEMOLYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_65 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_65,
        possibleRootCauses: [        
            RootCause.HEMOLYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_66 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_66,
        possibleRootCauses: [        
            RootCause.ACUTE_HEMOLYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_67 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_67,
        possibleRootCauses: [        
            RootCause.CHRONIC_HEMOLYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_68 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_68,
        possibleRootCauses: [        
            RootCause.ACUTE_HEMOLYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_69 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_69,
        possibleRootCauses: [        
            RootCause.CHRONIC_HEMOLYTIC_ANEMIA
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_70 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_70,
        possibleRootCauses: [        
            RootCause.INFECTION
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_71 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_71,
        possibleRootCauses: [        
            RootCause.CHRONIC_INFECTION
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_72 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_72,
        possibleRootCauses: [        
            RootCause.ACUTE_INFECTION
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_73 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_73,
        possibleRootCauses: [        
            RootCause.IMMUNE_ABNORMALITY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_74 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_74,
        possibleRootCauses: [
            RootCause.ACUTE_INNATE_IMMUNE_RESPONSE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_75 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_75,
        possibleRootCauses: [
            RootCause.ACUTE_ADAPTIVE_IMMUNE_RESPONSE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_76 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_76,
        possibleRootCauses: [
            RootCause.CHRONIC_INNATE_IMMUNE_RESPONSE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_77 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_77,
        possibleRootCauses: [
            RootCause.CHRONIC_ADAPTIVE_IMMUNE_RESPONSE
        ],
        isDeterminedOnlyByRBC: true
    });

    // --- RBC: WBC optimal + NLR non-optimal ---
    static CATEGORY_78 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_78,
        possibleRootCauses: [
            RootCause.INNATE_IMMUNE_RESPONSE
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_79 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_79,
        possibleRootCauses: [
            RootCause.ADAPTIVE_IMMUNE_RESPONSE
        ],
    isDeterminedOnlyByRBC: true
    });

    static CATEGORY_8 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_8,
        possibleRootCauses: [        
            RootCause.VITAMIN_B12_FOLATE_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_80 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_80,
        possibleRootCauses: [        
            RootCause.STOMACH_ACID_INSUFFICIENCY_POSSIBLY_CAUSING_IRON_INSUFFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_81 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_81,
        possibleRootCauses: [        
            RootCause.VITAMIN_B12_STOMACH_ACID_DEFICIENCY,
            RootCause.FOLATE_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_82 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_82,
        possibleRootCauses: [        
            RootCause.ZINC_INSUFFICIENCY_STOMACH_ACID
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_83 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_83,
        possibleRootCauses: [        
            RootCause.THIAMINE_B1_INSUFFICIENCY_STOMACH_ACID
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_84 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_84,
        possibleRootCauses: [        
            RootCause.THIAMINE_B1_INSUFFICIENCY_ERYTHROBLASTS
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_85 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_85,
        possibleRootCauses: [        
            RootCause.CHLORIDE_INSUFFICIENCY_STOMACH_ACID
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_86 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_86,
        possibleRootCauses: [        
            RootCause.CHLORIDE_INSUFFICIENCY_DECREASED_ADRENAL
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_9 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_9,
        possibleRootCauses: [        
            RootCause.VITAMIN_C_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: false
    });

    static CATEGORY_91 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_91,
        possibleRootCauses: [        
            RootCause.COPPER_DEFICIENCY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_92 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_92,
        possibleRootCauses: [        
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_93 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_93,
        possibleRootCauses: [        
            RootCause.CHRONIC_EXCESSIVE_ALCOHOL
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_94 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_94,
        possibleRootCauses: [        
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ],
        isDeterminedOnlyByRBC: true
    });

    static CATEGORY_150 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_200 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_200,
        possibleRootCauses: [
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ]
    });

    static CATEGORY_201 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_201,
        possibleRootCauses: [
            RootCause.BLOOD_LOSS_ACUTE
        ]
    });

    static CATEGORY_202 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_202,
        possibleRootCauses: [
            RootCause.BLOOD_LOSS_ACUTE
        ]
    });

    static CATEGORY_203 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_203,
        possibleRootCauses: [
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ]
    });

    static CATEGORY_204 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_204,
        possibleRootCauses: [
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ]
    });

    static CATEGORY_205 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_205,
        possibleRootCauses: [
            RootCause.B2_RIBOFLAVIN_INSUFFICIENCY,
            RootCause.LOW_TESTOSTERONE
        ]
    });

    static CATEGORY_206 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_206,
        possibleRootCauses: [
            RootCause.VITAMIN_C_DEFICIENCY
        ]
    });

    static CATEGORY_207 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_207,
        possibleRootCauses: [
           RootCause.HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_300 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_300,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY
        ]
    });

    static CATEGORY_301 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_301,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY_B12_DEFICIENCY
        ]
    });

    static CATEGORY_302 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_302,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_DEFICIENCY
        ]
    });

    static CATEGORY_303 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_303,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_B12_DEFICIENCY
        ]
    });

    static CATEGORY_304 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_304,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_DEFICIENCY,
            RootCause.UNDETERMINED_SERUM_IRON_STATUS
        ]
    });

    static CATEGORY_305 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_305,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_B12_DEFICIENCY,
            RootCause.UNDETERMINED_SERUM_IRON_STATUS
        ]
    });

    static CATEGORY_306 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_306,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY
        ]
    });

    static CATEGORY_307 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_307,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY_B12_DEFICIENCY,
            RootCause.IRON_INSUFFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY
        ]
    });

    static CATEGORY_308 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_308,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_DEFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY
        ]
    });

    static CATEGORY_309 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_309,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_B12_DEFICIENCY,
            RootCause.IRON_STORAGE_DEFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY
        ]
    });

    static CATEGORY_310 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_310,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY,
            RootCause.UNDETERMINED_SERUM_IRON_STATUS
        ]
    });

    static CATEGORY_311 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_311,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_B12_DEFICIENCY,
            RootCause.IRON_STORAGE_INSUFFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY,
            RootCause.UNDETERMINED_SERUM_IRON_STATUS
        ]
    });

    static CATEGORY_312 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_312,
        possibleRootCauses: [
            RootCause.STOMACH_ACID_INSUFFICIENCY_POSSIBLY_CAUSING_IRON_AND_OR_B12_INSUFFICIENCY
        ]
    });

    static CATEGORY_313 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_313,
        possibleRootCauses: [
            RootCause.STOMACH_ACID_INSUFFICIENCY_POSSIBLY_CAUSING_IRON_STORAGE_AND_OR_B12_INSUFFICIENCY
        ]
    });

    static CATEGORY_314 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_314,
        possibleRootCauses: [
            RootCause.VITAMIN_C_DEFICIENCY
        ]
    });

    static CATEGORY_400 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_400,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY
        ]
    });

    static CATEGORY_401 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_401,
        possibleRootCauses: [
            RootCause.IRON_INSUFFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY
        ]
    });

    static CATEGORY_402 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_402,
        possibleRootCauses: [
            RootCause.STOMACH_ACID_INSUFFICIENCY_POSSIBLY_CAUSING_IRON_INSUFFICIENCY
        ]
    });

    // static CATEGORY_405 = new PossibleRootCauseCategory({
    //     rootCauseCategory: RootCauseCategory.CATEGORY_405,
    //     possibleRootCauses: [
    //         RootCause.VITAMIN_B6_DEFICIENCY
    //     ]
    // });

    // static CATEGORY_406 = new PossibleRootCauseCategory({
    //     rootCauseCategory: RootCauseCategory.CATEGORY_406,
    //     possibleRootCauses: [
    //         RootCause.ZINC_DEFICIENCY
    //     ]
    // });

    static CATEGORY_425 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_425,
        possibleRootCauses: [
            RootCause.VITAMIN_A_DEFICIENCY
        ]
    });

    static CATEGORY_408 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_408,
        possibleRootCauses: [
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS
        ]
    });

    static CATEGORY_409 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_409,
        possibleRootCauses: [
            RootCause.IRON_DEFCIENCY_AND_CHRONIC_INFLAMMATION_ILLNESS
        ]
    });

    static CATEGORY_410 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_410,
        possibleRootCauses: [
            RootCause.IRON_DEFCIENCY_AND_CHRONIC_INFECTION
        ]
    });

    static CATEGORY_411 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_411,
        possibleRootCauses: [
            RootCause.IRON_DEFCIENCY_AND_ACUTE_INFECTION
        ]
    });

    static CATEGORY_412 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_412,
        possibleRootCauses: [
            RootCause.THALASSEMIA
        ]
    });

    static CATEGORY_414 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_414,
        possibleRootCauses: [
            RootCause.VITAMIN_B6_DEFICIENCY,
            RootCause.ZINC_DEFICIENCY,
            RootCause.VITAMIN_A_DEFICIENCY
        ]
    });

    static CATEGORY_415 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_415,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_DEFICIENCY
        ]
    });

    static CATEGORY_416 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_416,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_DEFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY
        ]
    });

    static CATEGORY_417 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_417,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_DEFICIENCY,
            RootCause.UNDETERMINED_SERUM_IRON_STATUS
        ]
    });

    static CATEGORY_418 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_418,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_CAUSED_BY_COPPER_INSUFFICIENCY,
            RootCause.UNDETERMINED_SERUM_IRON_STATUS
        ]
    });

    static CATEGORY_419 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_419,
        possibleRootCauses: [
            RootCause.IRON_STORAGE_INSUFFICIENCY_STOMACH_ACID_INSUFFICIENCY_ONLY
        ]
    });

    static CATEGORY_420 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_420,
        possibleRootCauses: [
            RootCause.IRON_DEFCIENCY_AND_IMMUNE_ABNORMALITY
        ]
    });

    static CATEGORY_423 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_423,
        possibleRootCauses: [
            RootCause.VITAMIN_C_DEFICIENCY
        ]
    });

    static CATEGORY_500 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_500,
        possibleRootCauses: [
            RootCause.SIDEROBLASTIC_ANEMIA
        ]
    });

    static CATEGORY_501 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_501,
        possibleRootCauses: [
            RootCause.SIDEROBLASTIC_ANEMIA_VITB6
        ]
    });

    static CATEGORY_502 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_502,
        possibleRootCauses: [
            RootCause.SIDEROBLASTIC_ANEMIA_ZINC
        ]
    });

    static CATEGORY_503 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_503,
        possibleRootCauses: [
            RootCause.SIDEROBLASTIC_ANEMIA_VITB_ZINC
        ]
    });

    static CATEGORY_507 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_507,
        possibleRootCauses: [
            RootCause.BLOOD_LOSS_CHRONIC
        ]
    });

    static CATEGORY_508 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_508,
        possibleRootCauses: [
            RootCause.BLOOD_LOSS_CHRONIC
        ]
    });

    static CATEGORY_509 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_509,
        possibleRootCauses: [
            RootCause.SIDEROBLASTIC_ANEMIA_VITB_ZINC
        ]
    });

    static CATEGORY_603 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_603,
        possibleRootCauses: [
            RootCause.CONGENITAL_SPHEROCYTIC_ANEMIA
        ]
    });

    static CATEGORY_604 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_604,
        possibleRootCauses: [
            RootCause.HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_605 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_605,
        possibleRootCauses: [
            RootCause.HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_606 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_606,
        possibleRootCauses: [
            RootCause.ACUTE_HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_607 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_607,
        possibleRootCauses: [
            RootCause.CHRONIC_HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_608 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_608,
        possibleRootCauses: [
            RootCause.ACUTE_HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_609 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_609,
        possibleRootCauses: [
            RootCause.CHRONIC_HEMOLYTIC_ANEMIA
        ]
    });

    static CATEGORY_700 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_700,
        possibleRootCauses: [
            RootCause.INFECTION
        ]
    });

    static CATEGORY_701 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_701,
        possibleRootCauses: [
            RootCause.CHRONIC_INFECTION
        ]
    });

    static CATEGORY_702 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_702,
        possibleRootCauses: [
            RootCause.ACUTE_INFECTION
        ]
    });

    static CATEGORY_703 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_703,
        possibleRootCauses: [
            RootCause.IMMUNE_ABNORMALITY
        ]
    });

    // --- WBC Insights (section=WBC) equivalents of 70–77: 70000–70007 ---
    static CATEGORY_70000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70000,
        possibleRootCauses: [
            RootCause.INFECTION // “Immune System Abnormality” when WBC missing
        ]
    });

    static CATEGORY_70001 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70001,
        possibleRootCauses: [
            RootCause.CHRONIC_INFECTION // “Suppressed Immune Activity” (WBC < optimal)
        ]
    });

    static CATEGORY_70002 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70002,
        possibleRootCauses: [
            RootCause.ACUTE_INFECTION // “Acute Immune Activity” (WBC > optimal)
        ]
    });

    static CATEGORY_70003 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70003,
        possibleRootCauses: [
            RootCause.IMMUNE_ABNORMALITY // WBC optimal + Immune Abnormality ≥ 50%
        ]
    });

    static CATEGORY_70004 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70004,
        possibleRootCauses: [
            RootCause.ACUTE_INNATE_IMMUNE_RESPONSE // WBC high + NLR high
        ]
    });

    static CATEGORY_70005 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70005,
        possibleRootCauses: [
            RootCause.ACUTE_ADAPTIVE_IMMUNE_RESPONSE // WBC high + NLR low
        ]
    });

    static CATEGORY_70006 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70006,
        possibleRootCauses: [
            RootCause.CHRONIC_INNATE_IMMUNE_RESPONSE // WBC low + NLR high
        ]
    });

    static CATEGORY_70007 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_70007,
        possibleRootCauses: [
            RootCause.CHRONIC_ADAPTIVE_IMMUNE_RESPONSE // WBC low + NLR low
        ]
    });

    // --- WBC: WBC optimal + NLR non-optimal ---
    static CATEGORY_70008 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70008,
    possibleRootCauses: []
    });

    static CATEGORY_70009 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70009,
    possibleRootCauses: []
    });

    // --- Eosinophils, Monocytes, Basophils Patterns ---
    static CATEGORY_70010 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70010,
    possibleRootCauses: []
    });

    static CATEGORY_70011 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70011,
    possibleRootCauses: []
    });

    static CATEGORY_70012 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70012,
    possibleRootCauses: []
    });

    static CATEGORY_70013 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70013,
    possibleRootCauses: []
    });

    static CATEGORY_70014 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70014,
    possibleRootCauses: []
    });

    static CATEGORY_70015 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70015,
    possibleRootCauses: []
    });

    static CATEGORY_70016 = new PossibleRootCauseCategory({
    rootCauseCategory: RootCauseCategory.CATEGORY_70016,
    possibleRootCauses: []
    });

    static CATEGORY_800 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_800,
        possibleRootCauses: [
            RootCause.VITAMIN_B12_FOLATE_DEFICIENCY
        ]
    });

    static CATEGORY_801 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_801,
        possibleRootCauses: [
            RootCause.VITAMIN_B12_STOMACH_ACID_DEFICIENCY,
            RootCause.FOLATE_DEFICIENCY
        ]
    });

    static CATEGORY_802 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_802,
        possibleRootCauses: [
            RootCause.ZINC_INSUFFICIENCY_STOMACH_ACID
        ]
    });

    static CATEGORY_803 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_803,
        possibleRootCauses: [
            RootCause.THIAMINE_B1_INSUFFICIENCY_STOMACH_ACID
        ]
    });

    static CATEGORY_804 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_804,
        possibleRootCauses: [
            RootCause.THIAMINE_B1_INSUFFICIENCY_ERYTHROBLASTS
        ]
    });

    static CATEGORY_805 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_805,
        possibleRootCauses: [
            RootCause.CHLORIDE_INSUFFICIENCY_STOMACH_ACID
        ]
    });

    static CATEGORY_806 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_806,
        possibleRootCauses: [
            RootCause.CHLORIDE_INSUFFICIENCY_DECREASED_ADRENAL
        ]
    });

    static CATEGORY_901 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_901,
        possibleRootCauses: [
            RootCause.COPPER_DEFICIENCY
        ]
    });

    static CATEGORY_902 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_902,
        possibleRootCauses: [        
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ]
    });

    static CATEGORY_903 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_903,
        possibleRootCauses: [        
            RootCause.CHRONIC_EXCESSIVE_ALCOHOL
        ]
    });

    static CATEGORY_904 = new PossibleRootCauseCategory({ 
        rootCauseCategory: RootCauseCategory.CATEGORY_904,
        possibleRootCauses: [        
            RootCause.IMPAIRED_THYROID_PHYSIOLOGY
        ]
    });

    static CATEGORY_949 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_949,
        possibleRootCauses: [
            RootCause.COPPER_EXCESS,
        ]
    });

    static CATEGORY_950 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_950,
        possibleRootCauses: [
            RootCause.CHRONIC_DISEASE,
            RootCause.OXIDATIVE_STRESS,
        ]
    });

    static CATEGORY_951 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_951,
        possibleRootCauses: [
            RootCause.ZINC_DEFICIENCY,
            RootCause.LEAD_TOXICITY
        ]
    });

    static CATEGORY_952 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_952,
        possibleRootCauses: [
            RootCause.ZINC_DEFICIENCY,
            RootCause.LEAD_TOXICITY
        ]
    });

    static CATEGORY_955 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_955,
        possibleRootCauses: [
            RootCause.ACUTE_INFECTION_ZINC_DEFICIENCY
        ]
    });

    static CATEGORY_960 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_960,
        possibleRootCauses: [
            RootCause.CHRONIC_INFECTION_ZINC_DEFICIENCY
        ]
    });

    static CATEGORY_1000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1200 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1200,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1300 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1300,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1400 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1400,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1755 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1755,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1760 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1760,
        possibleRootCauses: [
        ]
    });

        static CATEGORY_1761 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1761,
        possibleRootCauses: [
        ]
    });

        static CATEGORY_1762 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1762,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_1765 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_1765,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2180 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2180,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2190 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2190,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2200 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2200,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2210 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2210,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2220 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2220,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2230 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2230,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2240 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2240,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2250 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2250,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2260 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2260,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2270 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2270,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2280 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2280,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2290 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2290,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2300 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2300,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2310 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2310,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2320 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2320,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2330 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2330,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2340 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2340,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2350 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2350,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2360 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2360,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2370 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2370,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2380 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2380,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2390 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2390,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2400 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2400,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2410 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2410,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2420 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2420,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2430 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2430,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2440 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2440,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2450 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2450,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2460 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2460,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_2470 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_2470,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3015 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3015,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3172 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3172,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_3174 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_3174,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_4170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_4170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_5070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_5070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6075 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6075,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6076 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6076,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6077 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6077,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6085 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6085,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_6091 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6091,
        possibleRootCauses: [
        ]
    });

        static CATEGORY_6092 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6092,
        possibleRootCauses: [
        ]
    });

        static CATEGORY_6094 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6094,
        possibleRootCauses: [
        ]
    });

        static CATEGORY_6096 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6096,
        possibleRootCauses: [
        ]
    });

        static CATEGORY_6098 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_6098,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_7090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_7090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8072 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8072,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8074 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8074,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8076 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8076,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8078 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8078,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8180 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8180,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8190 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8190,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8200 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8200,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8210 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8210,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8220 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8220,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8230 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8230,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8240 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8240,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8250 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8250,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8260 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8260,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8270 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8270,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8280 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8280,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8290 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8290,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8300 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8300,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_8310 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_8310,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9032 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9032,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9034 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9034,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_9120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_9120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_10090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_10090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11055 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11055,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11057 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11057,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11063 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11063,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11065 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11065,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11068 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11068,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11075 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11075,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11078 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11078,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11082 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11082,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11084 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11084,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11086 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11086,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11088 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11088,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11091 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11091,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11093 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11093,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11095 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11095,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11099 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11099,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11200 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11200,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11210 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11210,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11220 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11220,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11230 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11230,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11240 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11240,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11250 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11250,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11260 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11260,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11270 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11270,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11280 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11280,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11290 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11290,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11300 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11300,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11310 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11310,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11320 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11320,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11330 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11330,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11340 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11340,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11350 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11350,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11360 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11360,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_11370 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_11370,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_12000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_12000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_12005 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_12005,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_12010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_12010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_12015 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_12015,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_12020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_12020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_12025 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_12025,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_13170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_13170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14072 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14072,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14074 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14074,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14180 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14180,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_14190 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_14190,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15005 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15005,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15006 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15006,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15110,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15120 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15120,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15130 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15130,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15140 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15140,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15150 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15150,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15160 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15160,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15170 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15170,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15180 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15180,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15190 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15190,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15192 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15192,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15194 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15194,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15200 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15200,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15210 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15210,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15220 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15220,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15230 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15230,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15240 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15240,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15250 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15250,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15260 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15260,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15270 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15270,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15280 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15280,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15290 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15290,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15300 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15300,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15310 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15310,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15320 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15320,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15330 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15330,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15340 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15340,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15350 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15350,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15360 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15360,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15370 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15370,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15380 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15380,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15390 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15390,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15400 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15400,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15410 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15410,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15420 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15420,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15430 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15430,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15440 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15440,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_15450 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_15450,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16010,
        possibleRootCauses: [
        ]
    });
    
    static CATEGORY_16020 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16020,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16030 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16030,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16040 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16040,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16050 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16050,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16060 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16060,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16070 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16070,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16080 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16080,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16090 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16090,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16091 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16091,
        possibleRootCauses: [
        ]
    });
    static CATEGORY_16092 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16092,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16094 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16094,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16095 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16095,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16097 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16097,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16100 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16100,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_16110 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_16110,
        possibleRootCauses: [
        ]
    });

    //12-10-25 MA - Prostate Markers
    static CATEGORY_17000 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_17000,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_17005 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_17005,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_17010 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_17010,
        possibleRootCauses: [
        ]
    });

    static CATEGORY_17015 = new PossibleRootCauseCategory({
        rootCauseCategory: RootCauseCategory.CATEGORY_17015,
        possibleRootCauses: [
        ]
    });

    rootCauseCategory: RootCauseCategory;
    possibleRootCauses: RootCause[];
    isDeterminedOnlyByRBC?: boolean;

    constructor(possibleRootCauseCategory?: PossibleRootCauseCategory) {
        // This handles copying the simple properties
        if (!possibleRootCauseCategory) {
            return;
        }
        // This handles copying the simple properties
        Object.keys(possibleRootCauseCategory).forEach(key => {
            this[key] = possibleRootCauseCategory[key];
        });
    }

    static hasAnyRootCauseCategories(possibleRootCauseCategories: PossibleRootCauseCategory[],
                                     ...rootCauseCategories: RootCauseCategory[]): boolean {
        if (!possibleRootCauseCategories || !rootCauseCategories) {
            return false;
        }

        const possibleRootCauses = possibleRootCauseCategories.map(
            (possibleRootCauseCategory: PossibleRootCauseCategory) => {
                return possibleRootCauseCategory.rootCauseCategory;
            }
        );
        
        const matches = rootCauseCategories.some((rootCauseCategory: RootCauseCategory) => {
            return possibleRootCauses.indexOf(rootCauseCategory) > -1;
        });

        return matches;
    }

    static isDeterminedOnlyByRBC(possibleRootCauseCategories: PossibleRootCauseCategory[]): boolean {
        return possibleRootCauseCategories.some(
            (possibleRootCauseCategory: PossibleRootCauseCategory) => {
                return possibleRootCauseCategory.isDeterminedOnlyByRBC;
            }
        );
    }

    static removePossibleRootCausesDeterminedOnlyByRBC(possibleRootCauseCategories: PossibleRootCauseCategory[]): 
        PossibleRootCauseCategory[] {
        if (!possibleRootCauseCategories) {
            return possibleRootCauseCategories;
        }

        return possibleRootCauseCategories.filter(
            (possibleRootCauseCategory: PossibleRootCauseCategory) => {
                // Filter out anything determined by RBC
                return !possibleRootCauseCategory.isDeterminedOnlyByRBC;
            }
        );
    }

    static removePossibleRootCauseCategories(
        possibleRootCauseCategories: PossibleRootCauseCategory[], ...rootCauseCategories: RootCauseCategory[]): 
        PossibleRootCauseCategory[] {

        if (!possibleRootCauseCategories || !rootCauseCategories) {
            return possibleRootCauseCategories;
        }
        
        return possibleRootCauseCategories.filter((possibleRootCauseCategory: PossibleRootCauseCategory) => {
            return rootCauseCategories.indexOf(possibleRootCauseCategory.rootCauseCategory) === -1;
        });
    }

    static sort(possibleRootCauseCategories: PossibleRootCauseCategory[]): PossibleRootCauseCategory[] {
        return _.sortBy(possibleRootCauseCategories, ['rootCauseCategory']);
    }

    static sortForWBC(possibleRootCauseCategories: PossibleRootCauseCategory[]): PossibleRootCauseCategory[] {
  const IMMUNE_PROB_CATS = new Set<RootCauseCategory>([
    RootCauseCategory.CATEGORY_11099,
    RootCauseCategory.CATEGORY_11095,
    RootCauseCategory.CATEGORY_11093,
    RootCauseCategory.CATEGORY_11091,
    RootCauseCategory.CATEGORY_11090,
    RootCauseCategory.CATEGORY_11088,
    RootCauseCategory.CATEGORY_11086,
    RootCauseCategory.CATEGORY_11084,
    RootCauseCategory.CATEGORY_11082,
    RootCauseCategory.CATEGORY_11080,
    RootCauseCategory.CATEGORY_11078,
    RootCauseCategory.CATEGORY_11075,
    RootCauseCategory.CATEGORY_11070,
    RootCauseCategory.CATEGORY_11068,
    RootCauseCategory.CATEGORY_11065,
    RootCauseCategory.CATEGORY_11063,
    RootCauseCategory.CATEGORY_11060,
    RootCauseCategory.CATEGORY_11057,
    RootCauseCategory.CATEGORY_11055,
    RootCauseCategory.CATEGORY_11050,
    RootCauseCategory.CATEGORY_11010,
  ]);

  const probScore = (rc: RootCauseCategory): number => {
    switch (rc) {
      case RootCauseCategory.CATEGORY_11099: return 99;
      case RootCauseCategory.CATEGORY_11095: return 95;
      case RootCauseCategory.CATEGORY_11093: return 93;
      case RootCauseCategory.CATEGORY_11091: return 91;
      case RootCauseCategory.CATEGORY_11090: return 90;
      case RootCauseCategory.CATEGORY_11088: return 88;
      case RootCauseCategory.CATEGORY_11086: return 86;
      case RootCauseCategory.CATEGORY_11084: return 84;
      case RootCauseCategory.CATEGORY_11082: return 82;
      case RootCauseCategory.CATEGORY_11080: return 80;
      case RootCauseCategory.CATEGORY_11078: return 69;
      case RootCauseCategory.CATEGORY_11075: return 69;
      case RootCauseCategory.CATEGORY_11070: return 68;
      case RootCauseCategory.CATEGORY_11068: return 67;
      case RootCauseCategory.CATEGORY_11065: return 65;
      case RootCauseCategory.CATEGORY_11063: return 63;
      case RootCauseCategory.CATEGORY_11060: return 60;
      case RootCauseCategory.CATEGORY_11057: return 57;
      case RootCauseCategory.CATEGORY_11055: return 55;
      case RootCauseCategory.CATEGORY_11050: return 50;
      case RootCauseCategory.CATEGORY_11010: return 10;
      default: return -1;
    }
  };

  return _.sortBy(
    possibleRootCauseCategories,
    [
      // 1) Put immune-probability entries first
      (p: PossibleRootCauseCategory) => (IMMUNE_PROB_CATS.has(p.rootCauseCategory) ? 0 : 1),
      // 2) Within those, sort by probability descending
      (p: PossibleRootCauseCategory) => -probScore(p.rootCauseCategory),
      // 3) Fallback by numeric category ascending
      (p: PossibleRootCauseCategory) => p.rootCauseCategory,
    ]
  );
}
 
}
